module.exports = __webpack_public_path__ + "img/dashboard-error.4700c27f.svg";